import React from 'react';
import { FadeIn } from './Shared';
export const StatsBar = () => {
  return <div className="bg-navy-800 border-y border-navy-700 py-6" data-id="element-285">
      <div className="max-w-6xl mx-auto px-4" data-id="element-286">
        <FadeIn data-id="element-287">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-navy-700" data-id="element-288">
            <div data-id="element-289">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-290">
                +1.200
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-291">
                familias
              </div>
            </div>
            <div data-id="element-292">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-293">
                5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-294">
                Tomos
              </div>
            </div>
            <div data-id="element-295">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-296">
                5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-297">
                Bonos
              </div>
            </div>
            <div data-id="element-298">
              <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-299">
                4.9/5
              </div>
              <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-300">
                ⭐⭐⭐⭐⭐
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </div>;
};